// apps/web/src/api/services/auth.service.ts
import { HttpClient } from '../http-client';
import { ApiResponse, LoginRequest, LoginResponse } from '@gym-management/shared';
import { AxiosResponse } from 'axios';

export class AuthService extends HttpClient {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response: AxiosResponse<ApiResponse<LoginResponse>> = await this.post('/api/auth/login', {
      email,
      password,
    } as LoginRequest);
    if (response.data.success && response.data.data) {
      const { token } = response.data.data;
      localStorage.setItem('token', token);
      return response.data.data;
    }
    throw new Error(response.data.message || 'Failed to login');
  }

  logout(): void {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  clearToken() {
    localStorage.removeItem('token');
  }
}
